import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDatepickerIntl } from '@angular/material/datepicker';
import { TranslocoService } from '@jsverse/transloco';

/**
 * Übersetzt die Beschriftungen des Material-Datepicker-Kalenders (u. a. die als `matTooltip`
 * gerenderten Vor-/Zurück-Buttons für Monat/Jahr), die Material sonst nur in Englisch liefert.
 * Global via `{ provide: MatDatepickerIntl, useClass: EwsDatepickerIntl }` registriert; reagiert
 * auf Sprachwechsel und ruft `changes.next()`, damit der offene Kalender die Labels neu einliest.
 */
@Injectable()
export class EwsDatepickerIntl extends MatDatepickerIntl {
	private readonly transloco = inject(TranslocoService);
	private readonly destroyRef = inject(DestroyRef);

	constructor() {
		super();
		this.transloco.langChanges$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => this.updateLabels());
		this.updateLabels();
	}

	private updateLabels(): void {
		const t = (key: string): string => this.transloco.translate(`datepicker.${key}`);

		this.calendarLabel = t('calendarLabel');
		this.openCalendarLabel = t('openCalendarLabel');
		this.closeCalendarLabel = t('closeCalendarLabel');
		this.prevMonthLabel = t('prevMonthLabel');
		this.nextMonthLabel = t('nextMonthLabel');
		this.prevYearLabel = t('prevYearLabel');
		this.nextYearLabel = t('nextYearLabel');
		this.prevMultiYearLabel = t('prevMultiYearLabel');
		this.nextMultiYearLabel = t('nextMultiYearLabel');
		this.switchToMonthViewLabel = t('switchToMonthViewLabel');
		this.switchToMultiYearViewLabel = t('switchToMultiYearViewLabel');

		this.changes.next();
	}
}
